import { lazyLoad } from 'utils/loadable';

export const CatalogEdit = lazyLoad(
  () => import('./catalogEdit.page'),
  (module) => module.CatalogEdit
);
